// src/pages/EventPage.js

function EventPage() {
    return (
        <>
            <h1>Coming soon...</h1>
        </>
    );
}

export default EventPage;
